import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { ethers } from "ethers";
import { ADDRESSES, ABIS } from "../utils/contracts";

export default function FakeBaycDetail() {
  const { tokenId } = useParams();
  const [metadata, setMetadata] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMetadata = async () => {
      if (!window.ethereum) return;
      const provider = new ethers.BrowserProvider(window.ethereum);
      const contract = new ethers.Contract(ADDRESSES.BAYC, ABIS.BAYC, provider);

      try {
        // 1. Check if token exists
        try {
            await contract.ownerOf(tokenId);
        } catch (e) {
            throw new Error("Token does not exist");
        }

        // 2. Get URI
        let tokenUri = await contract.tokenURI(tokenId);
        
        // 3. Convert IPFS to HTTP
        if (tokenUri.startsWith("ipfs://")) {
          tokenUri = tokenUri.replace("ipfs://", "https://ipfs.io/ipfs/");
        }

        // 4. Fetch JSON
        const response = await fetch(tokenUri);
        const data = await response.json();
        
        // 5. Handle Image IPFS conversion inside JSON
        if (data.image && data.image.startsWith("ipfs://")) {
            data.image = data.image.replace("ipfs://", "https://ipfs.io/ipfs/");
        }

        setMetadata(data);
      } catch (err) {
        setError(err.message);
      }
    };

    fetchMetadata();
  }, [tokenId]);

  if (error) return <div style={{color: "red"}}>Error: {error}</div>;
  if (!metadata) return <div>Loading metadata...</div>;

  return (
    <div>
      <h2>Token #{tokenId}</h2>
      <img src={metadata.image} alt="NFT" style={{ width: "300px", borderRadius: "10px" }} />
      <h3>Attributes:</h3>
      <ul>
        {metadata.attributes?.map((attr, index) => (
          <li key={index}><strong>{attr.trait_type}:</strong> {attr.value}</li>
        ))}
      </ul>
    </div>
  );
}